import { render, staticRenderFns } from "./MColourPopupEdit.vue?vue&type=template&id=48b27e3a&scoped=true"
import script from "./MColourPopupEdit.vue?vue&type=script&lang=js"
export * from "./MColourPopupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b27e3a",
  null
  
)

export default component.exports